import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import { TournamentService } from '@/modules/tournament/api/services'
import type { paths } from '@/schema'

type CreateFromPresetRequest =
	paths['/api/admin/tournaments/from-preset']['post']['requestBody']['content']['application/json']
type CreateFromPresetResponse =
	paths['/api/admin/tournaments/from-preset']['post']['responses']['201']['content']['application/json']

interface UseMutationCreateTournamentFromPresetOptions {
	onSuccess?: (data: CreateFromPresetResponse) => void
	onError?: (error: Error) => void
}

const useMutationCreateTournamentFromPreset = (
	options?: UseMutationCreateTournamentFromPresetOptions,
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (data: CreateFromPresetRequest) =>
			TournamentService.createTournamentFromPreset(data),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL,
			})
			toast.success('สร้างทัวร์นาเมนต์สำเร็จ')
			options?.onSuccess?.(data)
		},
		onError: (error) => {
			toast.error('ไม่สามารถสร้างทัวร์นาเมนต์ได้')
			options?.onError?.(error as Error)
		},
	})
}

export default useMutationCreateTournamentFromPreset
